// extracted by mini-css-extract-plugin
export default {"InstructionsWrapper":"InterventionImport_InstructionsWrapper__JqjXy","Instructions":"InterventionImport_Instructions__RRR3c"};